import React, { ChangeEvent, useState } from "react";
import FormDialog from "../../shared/FormDialog";
import { Box } from "@material-ui/core";
import CustomTextField from "../../shared/CustomTextField";
import ButtonNav from "../../shared/NavBar/ButtonNav";
import { useDispatch } from "react-redux";
import { setErrors, setSuccessMessage } from "../../store/alerts/alertsActions";
import useApiRequest from "../../utils/hook/useApiRequest";
import { RESET_PASSWORD } from "../../api/apiRoutes";

interface IProps {
  open: boolean;
  onClose: () => void;
}

const RemindPass: React.FC<IProps> = ({ open, onClose }: IProps) => {
  const [email, setEmail] = useState("");
  const dispatch = useDispatch();
  const { post } = useApiRequest();
  const onSubmit = async () => {
    if (email === "") {
      dispatch(setErrors(["Podaj adres email"]));
    } else {
      const { isError } = await post(RESET_PASSWORD, { email });
      if (!isError) {
        onClose();
        dispatch(setSuccessMessage("Email z nowym hasłem został wysłany"));
      }
    }
  };

  return (
    <FormDialog open={open} title={`Przypomnij hasło`} onClose={onClose} showTitle={true} hideActions={true}>
      <Box my={3} style={{ width: "60%", marginLeft: "20%" }}>
        <CustomTextField
          label={"Podaj email"}
          name={"email"}
          margin={"dense"}
          fullWidth
          value={email}
          onChange={(event: ChangeEvent<HTMLInputElement>) => setEmail(event.target.value)}
        />

        <ButtonNav type={"button"} onClick={onSubmit} fullWidth={true}>
          Wyślij
        </ButtonNav>
      </Box>
    </FormDialog>
  );
};

export default RemindPass;
